import * as React from 'react'
import { IconSVGType } from '../../../types/icons'

export const JCBCardIcon = (props: IconSVGType) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox={props.viewBox || '0 0 24 24'}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title id='jcb-card-icon'>JCB Card</title>
    <g clipPath='url(#clip0_3_7786)'>
      <rect x='3.75' y='9.09375' width='5.15625' height='6.1875' fill='white' />
      <rect
        x='9.42188'
        y='9.09375'
        width='5.15625'
        height='6.1875'
        fill='white'
      />
      <rect
        x='15.0938'
        y='9.09375'
        width='5.15625'
        height='6.1875'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.74455 6.00002C4.69864 6.0206 3.75222 6.95372 3.75222 7.99895C3.75222 8.58046 3.75178 10.8824 3.75133 13.1708C3.94541 13.2912 4.8794 13.5868 5.25513 13.6126C6.07764 13.6704 6.58794 13.4024 6.66699 12.7263L6.66299 10.2155H8.48211V12.669C8.38707 14.0737 7.13643 14.3605 5.23337 14.2659C4.74084 14.241 4.0711 14.1162 3.75089 14.0338C3.75044 16.324 3.75 18.375 3.75 18.375H6.91703C7.78129 18.375 8.90625 17.5789 8.90625 16.3682V6.00002H5.74455Z'
        fill='#12509F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.74455 6.00002C4.69864 6.0206 3.75222 6.95372 3.75222 7.99895C3.75222 8.58046 3.75178 10.8824 3.75133 13.1708C3.94541 13.2912 4.8794 13.5868 5.25513 13.6126C6.07764 13.6704 6.58794 13.4024 6.66699 12.7263L6.66299 10.2155H8.48211V12.669C8.38707 14.0737 7.13643 14.3605 5.23337 14.2659C4.74084 14.241 4.0711 14.1162 3.75089 14.0338C3.75044 16.324 3.75 18.375 3.75 18.375H6.91703C7.78129 18.375 8.90625 17.5789 8.90625 16.3682V6.00002H5.74455Z'
        fill='#12509F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.416 6C10.3705 6.02058 9.42365 6.95371 9.42365 7.99893C9.42365 8.36719 9.42365 9.42687 9.42321 10.7353C10.0587 10.2457 11.0838 10.0057 12.3877 10.1047C13.1294 10.1608 13.6783 10.2628 13.9777 10.3499V11.2187C13.6477 11.0562 12.9971 10.8145 12.4539 10.7764C11.2241 10.6888 10.5788 11.2572 10.5788 12.1755C10.5788 13.0017 11.0771 13.7094 12.4486 13.6152C12.9007 13.5841 13.6535 13.3245 13.9737 13.1743L13.9777 14.0168C13.7019 14.1021 12.8443 14.2865 12.0369 14.2931C10.8222 14.3027 9.96459 14.0483 9.42276 13.6354C9.42188 16.0805 9.42188 18.375 9.42188 18.375H12.5885C13.4527 18.375 14.5781 17.5789 14.5781 16.3682V6H11.416Z'
        fill='#EB212E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.416 6C10.3705 6.02058 9.42365 6.95371 9.42365 7.99893C9.42365 8.36719 9.42365 9.42687 9.42321 10.7353C10.0587 10.2457 11.0838 10.0057 12.3877 10.1047C13.1294 10.1608 13.6783 10.2628 13.9777 10.3499V11.2187C13.6477 11.0562 12.9971 10.8145 12.4539 10.7764C11.2241 10.6888 10.5788 11.2572 10.5788 12.1755C10.5788 13.0017 11.0771 13.7094 12.4486 13.6152C12.9007 13.5841 13.6535 13.3245 13.9737 13.1743L13.9777 14.0168C13.7019 14.1021 12.8443 14.2865 12.0369 14.2931C10.8222 14.3027 9.96459 14.0483 9.42276 13.6354C9.42188 16.0805 9.42188 18.375 9.42188 18.375H12.5885C13.4527 18.375 14.5781 17.5789 14.5781 16.3682V6H11.416Z'
        fill='#EB212E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0879 6C16.0428 6.02058 15.0955 6.95371 15.0955 7.99893C15.0955 8.31552 15.0955 9.14268 15.0955 10.1989H18.1058C18.7049 10.1989 19.4106 10.4515 19.4106 11.1692C19.4106 11.5545 19.2028 11.9911 18.4526 12.1321V12.1487C18.8905 12.1487 19.6495 12.4014 19.6495 13.1633C19.6495 13.9498 18.8297 14.1683 18.3905 14.1683L15.0946 14.1718C15.0942 16.4058 15.0938 18.375 15.0938 18.375H18.2608C19.125 18.375 20.25 17.5789 20.25 16.3682V6H17.0879Z'
        fill='#17A554'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0879 6C16.0428 6.02058 15.0955 6.95371 15.0955 7.99893C15.0955 8.31552 15.0955 9.14268 15.0955 10.1989H18.1058C18.7049 10.1989 19.4106 10.4515 19.4106 11.1692C19.4106 11.5545 19.2028 11.9911 18.4526 12.1321V12.1487C18.8905 12.1487 19.6495 12.4014 19.6495 13.1633C19.6495 13.9498 18.8297 14.1683 18.3905 14.1683L15.0946 14.1718C15.0942 16.4058 15.0938 18.375 15.0938 18.375H18.2608C19.125 18.375 20.25 17.5789 20.25 16.3682V6H17.0879Z'
        fill='#17A554'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1099 12.4386L16.1076 13.532L17.3476 13.5364C17.5888 13.5364 17.8921 13.3323 17.8921 12.9777C17.8921 12.6641 17.6301 12.4364 17.3494 12.4386C17.1731 12.4408 16.8893 12.4399 16.6361 12.4391C16.482 12.4386 16.339 12.4382 16.2378 12.4382C16.1787 12.4382 16.1343 12.4382 16.1099 12.4386Z'
        fill='#17A554'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1099 12.4386L16.1076 13.532L17.3476 13.5364C17.5888 13.5364 17.8921 13.3323 17.8921 12.9777C17.8921 12.6641 17.6301 12.4364 17.3494 12.4386C17.1731 12.4408 16.8893 12.4399 16.6361 12.4391C16.482 12.4386 16.339 12.4382 16.2378 12.4382C16.1787 12.4382 16.1343 12.4382 16.1099 12.4386Z'
        fill='#17A554'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1054 10.8255L16.1014 11.8208L17.2726 11.8291C17.468 11.8251 17.7411 11.6491 17.7411 11.3417C17.7411 11.0278 17.5022 10.8163 17.2482 10.822C17.0821 10.8259 16.8547 10.8241 16.6446 10.8224C16.5318 10.8215 16.4239 10.8206 16.3333 10.8206C16.228 10.8206 16.1458 10.822 16.1054 10.8255Z'
        fill='#17A554'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.1054 10.8255L16.1014 11.8208L17.2726 11.8291C17.468 11.8251 17.7411 11.6491 17.7411 11.3417C17.7411 11.0278 17.5022 10.8163 17.2482 10.822C17.0821 10.8259 16.8547 10.8241 16.6446 10.8224C16.5318 10.8215 16.4239 10.8206 16.3333 10.8206C16.228 10.8206 16.1458 10.822 16.1054 10.8255Z'
        fill='#17A554'
      />
    </g>
    <defs>
      <clipPath id='clip0_3_7786'>
        <rect
          width='16.5'
          height='12.375'
          fill='white'
          transform='translate(3.75 6)'
        />
      </clipPath>
    </defs>
  </svg>
)
